module.exports = __webpack_public_path__ + "img/aprovacaobrasil.5e6a423a.png";